"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CredentialType = void 0;
exports.CredentialType = {
    Jwt: 'Jwt',
    Guest: 'Guest',
    Wallet: 'Wallet',
    Service: 'Service',
    Password: 'Password',
    ApiKey: 'ApiKey',
    Impersonate: 'Impersonate',
};
//# sourceMappingURL=credential.js.map